
import {ShCompanySearch} from 'components/search-dropdown'

export default {
  components: {ShCompanySearch},
  emits: ['submit'],
  data() {
    return {
      id: undefined,
      name: undefined,
      name_valid: false,
      shared_company_id: undefined,
      email_domain: undefined,
      email_domain_valid: false
    }
  },
  computed: {
    can_submit() {
      return this.name_valid && this.email_domain_valid && !!this.shared_company_id
    }
  },
  methods: {
    open(data){
      this.id = data.id
      this.name = data.name
      this.name_valid = true
      this.shared_company_id = data.shared_company_id
      this.email_domain = data.email_domain
      this.email_domain_valid = true
      this.$refs.modal.open()
      this.$nextTick(() => this.$refs.i_name.focus())
    },
    close() {
      this.$refs.modal.close()
      
    },
    submit() {
      this.close()
      this.$emit('submit', {
        id: this.id, 
        name: this.name, 
        shared_company_id: this.shared_company_id, 
        email_domain: this.email_domain
      })
    }
  }
}
